import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom"; // useLocation for current route

export default function NavbarComponent({ isLoggedIn, setIsLoggedIn }) {
  const location = useLocation(); // Get current location to highlight active nav item
  const navigate = useNavigate();
  // const [isLoggedIn, setIsLoggedIn] = useState(false)

  // let token = localStorage.getItem("token");
  //  const handleLogout = () => {
  //     localStorage.removeItem("token");
  //     if(localStorage.getItem("token") === null){
  //       setIsLoggedIn(false);
  //     }

  //   }
  //  useEffect(() => {
  //    if (token !== null) {
  //      setIsLoggedIn(true);
  //    }
  //  }, [token])
  const handleLogout = () => {
    localStorage.removeItem("token");
    if (localStorage.getItem("token") === null) {
      setIsLoggedIn(false);
      navigate("/login");
    }
  };
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container fluid>
        <Navbar.Brand as={NavLink} to="/">
          Fitness Tracker
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav activeKey={location.pathname}>
            <Nav.Link as={Link} to="/" exact="true">
              Home
            </Nav.Link>

            {isLoggedIn === true ? (
              <>
                <Nav.Link as={Link} to="/workout" eventKey="/workout">
                  Workout
                </Nav.Link>
                <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/register" eventKey="/register">
                  Register
                </Nav.Link>
                <Nav.Link as={Link} to="/login" eventKey="/login">
                  Login
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
